import * as React from 'react';

import { ActivityIndicator } from '@mam/main/UI';
import { Redirect } from 'react-router-dom';
import ServerErrorPage from '~/UI/ServerErrorPage/ServerErrorPage';

import { ERPPackError, ERPPackRequest, ERPPackResponse } from './api/ERPPackRequest';

import { useApiResult } from '@mam/main/ApiHooks';
import { useFetchOrGetVirtualBrand } from './hooks/useFetchOrGetVirtualBrand';
import { useSelector } from 'react-redux';

import { createErpSessionLink } from './utils/url';

import type { ApplicationState } from '~/Store';

const ERPSessionRedirect = ({ virtualBrandId, virtualPackId }: { virtualBrandId: string; virtualPackId: string }) => {
	const userId = useSelector(({ accessToken }: ApplicationState) => accessToken.accessToken?.user.id);

	const result = useFetchOrGetVirtualBrand(virtualBrandId, virtualPackId);

	const [erpPackResult] = useApiResult<ERPPackRequest, ERPPackResponse, ERPPackError>(
		userId ? new ERPPackRequest(userId, virtualPackId) : null,
		[userId, virtualPackId]
	);

	const erpPack = erpPackResult.value?.erpPack;

	if (result.fetching || erpPackResult.isLoading || !erpPack) {
		return <ActivityIndicator />;
	}

	if (erpPackResult.error) {
		return <ServerErrorPage error={erpPackResult.error} />;
	}

	// NOTE: use force window redirect to prevent UI flicking
	return <Redirect to={createErpSessionLink(erpPack.erpSession.id, erpPack.id)} />;
};

export default React.memo(ERPSessionRedirect);
